import React from "react";
import { ShieldCheck, Brain, Clock, HeartHandshake, MapPin, Sparkles } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhyWorkWithUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = [{
    title: "Dijital Gülüş Tasarımı",
    description: "Tedavi öncesi sonucunuzu dijital ortamda planlıyor, hayalinizdeki gülüşü anatomik yapınıza uygun şekilde tasarlıyoruz.",
    icon: Brain
  }, {
    title: "Üst Düzey Hijyen Standartları",
    description: "Uluslararası sterilizasyon protokollerini titizlikle uygulayarak, güvenli ve sağlıklı bir klinik ortamı sunuyoruz.",
    icon: ShieldCheck
  }, {
    title: "Estetik ve Fonksiyonel Çözümler",
    description: "Sadece güzel bir gülüş değil, aynı zamanda uzun ömürlü ve sağlıklı bir ağız yapısı için kaliteli materyaller kullanıyoruz.",
    icon: Sparkles
  }, {
    title: "Hızlı ve Etkin Tedavi Süreci",
    description: "Modern diş hekimliği teknolojileri sayesinde, minimum sürede maksimum konfor ve kalıcı sonuçlar elde ediyoruz.",
    icon: Clock
  }, {
    title: "VIP Hasta Konforu",
    description: "Tedavi sürecinizin her anında kendinizi özel ve huzurlu hissetmeniz için kişiselleştirilmiş bir bakım deneyimi sağlıyoruz.",
    icon: HeartHandshake
  }, {
    title: "Merkezi ve Prestijli Konum",
    description: "Kayseri'nin kalbinde yer alan kliniğimizde, ulaşım kolaylığı ve lüks klinik donanımıyla hizmetinizdeyiz.",
    icon: MapPin
  }];
  return <section data-section-id="64823" id="kişiye-özel-tedavi-yaklaşımı" ref={ref} className="relative w-full py-24 overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-primary/5 rounded-full blur-3xl opacity-40" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[400px] h-[400px] bg-secondary/30 rounded-full blur-3xl opacity-40" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-4xl md:text-6xl font-serif font-light text-foreground mb-6 tracking-tight">
            Neden Ayşegül İnneci Uzun?
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed font-sans">Gülüşünüzü bir sanat eseri olarak ele alıyor; ileri teknolojiyi estetik bakış açımızla birleştirerek, beklentilerinizin ötesinde gülüşler hedefliyoruz.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, i) => <div key={i} data-index={i} className={`transition-all duration-700 ease-out delay-[${i * 100}ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
              <Card className="h-full border-none shadow-sm bg-card/40 backdrop-blur-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-500 group overflow-hidden rounded-sm">
                <CardHeader className="pb-4">
                  <div className="w-14 h-14 rounded-sm bg-secondary/80 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors duration-500">
                    <feature.icon className="w-7 h-7 text-primary group-hover:scale-110 transition-transform duration-500" strokeWidth={1} />
                  </div>
                  <CardTitle className="text-xl font-serif font-medium text-foreground group-hover:text-primary transition-colors tracking-wide">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base text-muted-foreground leading-relaxed font-sans">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>

        <div className={`mt-16 text-center transition-all duration-700 delay-500 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <Button asChild size="lg" className="rounded-sm px-10 py-7 text-lg bg-primary text-primary-foreground shadow-lg shadow-primary/10 hover:shadow-primary/20 hover:bg-primary/90 transition-all uppercase tracking-widest font-sans">
            <Link to="/ContactPage">
              Hemen Randevu Alın
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}